"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPostcodeWrapper$ = exports.AreaPostcodeWrapper$outboundSchema = exports.AreaPostcodeWrapper$inboundSchema = void 0;
exports.areaPostcodeWrapperToJSON = areaPostcodeWrapperToJSON;
exports.areaPostcodeWrapperFromJSON = areaPostcodeWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areapostcode_js_1 = require("./areapostcode.js");
/** @internal */
exports.AreaPostcodeWrapper$inboundSchema = z.object({
    attributes: areapostcode_js_1.AreaPostcode$inboundSchema,
    id: z.string(),
});
/** @internal */
exports.AreaPostcodeWrapper$outboundSchema = z.object({
    attributes: areapostcode_js_1.AreaPostcode$outboundSchema,
    id: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaPostcodeWrapper$;
(function (AreaPostcodeWrapper$) {
    /** @deprecated use `AreaPostcodeWrapper$inboundSchema` instead. */
    AreaPostcodeWrapper$.inboundSchema = exports.AreaPostcodeWrapper$inboundSchema;
    /** @deprecated use `AreaPostcodeWrapper$outboundSchema` instead. */
    AreaPostcodeWrapper$.outboundSchema = exports.AreaPostcodeWrapper$outboundSchema;
})(AreaPostcodeWrapper$ || (exports.AreaPostcodeWrapper$ = AreaPostcodeWrapper$ = {}));
function areaPostcodeWrapperToJSON(areaPostcodeWrapper) {
    return JSON.stringify(exports.AreaPostcodeWrapper$outboundSchema.parse(areaPostcodeWrapper));
}
function areaPostcodeWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaPostcodeWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaPostcodeWrapper' from JSON`);
}
//# sourceMappingURL=areapostcodewrapper.js.map